'use strict';

class GetEntries {
	constructor(el){
		this.wrap = el;
		this.filters = this.wrap.querySelectorAll('.js-entries__filter');
		this.body = this.wrap.querySelector('.js-entries__body');
		this.items = this.wrap.querySelector('.js-entries__items');
		this.more = this.wrap.querySelector('.js-entries__more');

		// this.category = this.wrap.querySelectorAll('.category__list a');

		this.controller = null;
		this.signal = null;
		this.render();
	}

	render(){
		this.filter();
		// this.sorts();
		if( this.more ) {
			this.moreEvent(this.more);
		}
	}


	filter(){

		// 複数選択の絞り込み（活用事例 /result/）。
		// .m_filter に data-filter-multi が付いているページだけこちらに入る。
		// 属性が無いページ（お知らせ／ソリューション／講座）は下の単一選択のまま
		const multi = this.wrap.querySelector('[data-filter-multi]');
		if( multi ) {
			this.filterMulti(multi);
			return;
		}

		//list
		let current = null;
		this.filters.forEach((filter)=>{
			if( filter.classList.contains('active') ) {
				current = filter;
			}
			filter.addEventListener('click', (e)=>{
				$('.category__list .item a').removeClass('active');
				e.preventDefault();
				if( filter.classList.contains('active') ) return;
				if( current ) {
					current.classList.remove('active');
				}
				current = filter;
				filter.classList.add('active');

				//selectをリセット
				const selects = this.wrap.querySelectorAll('select');
				$.each(selects, (i, select)=>{
						$.each(selects, (i, el)=>{
							if( el != select ) {
								el.value = '';
							}
						});
				});
				//ここまでselectをリセット

				this.get(filter.href, true);
			});
		});


		//select
		const selects = this.wrap.querySelectorAll('select');
		$.each(selects, (i, select)=>{
			select.addEventListener('change', (e)=>{
				$.each(selects, (i, el)=>{
					if( el != select ) {
						el.value = '';
					}
				});
				const url = select.value;

				//カテゴリーをリセット
				$('.category__list .item a').removeClass('active');
				$('.category__list .item a[data-sort="all"]').addClass('active');

				this.get(url, true);

			});
		});



	}

	// sorts(){
	// 	const sorts = document.querySelector('.js-sorts');
	// 	if ( !sorts ) return;
	// 	const
	// 		data_sorts = sorts.dataset.sorts,
	// 		links = sorts.querySelectorAll('a');
	// 	links.forEach((link)=>{
	// 		link.addEventListener('click', (e)=>{
	// 			e.preventDefault();
	// 			link.classList.toggle('is-current');
	// 			const all = link.closest('.sort__list').querySelector('[data-sort="all"]');
	// 			if ( link == all ) {
	// 				link.closest('.sort__list').querySelectorAll('a').forEach((el)=>{
	// 					if ( link != el && el.classList.contains('is-current') ) el.classList.remove('is-current');
	// 				});
	// 			} else if ( all.classList.contains('is-current') ) {
	// 				all.classList.remove('is-current');
	// 			}
	// 			let
	// 				url,
	// 				data = {},
	// 				query = {};
	// 			links.forEach((sort)=>{
	// 				if ( sort.classList.contains('is-current') ) {
	// 					const params = new URL(sort.href);
	// 					params.searchParams.forEach((val, key)=>{
	// 						if (!data[key] ) data[key] = [];
	// 						data[key].push(val);
	// 					});
	// 				}
	// 			});
	// 			for ( let key in data ) {
	// 				if (data[key].length ) {
	// 					query[key] = data[key].join(',');
	// 				}
	// 			}
	// 			if ( Object.keys(query).length ) {
	// 				url = `/${data_sorts}/?${new URLSearchParams(query).toString()}`;
	// 			} else {
	// 				url = `/${data_sorts}/`;
	// 				all.classList.add('is-current');
	// 			}
	// 			this.get(url, true);
	// 		});
	// 	});
	// }


	// 軸ごとに複数選べる絞り込み。
	//
	// ピルは data-param（クエリ変数名）と data-slug（タームのスラッグ）を持ち、
	// 選択中かどうかは .active で表す。押すたびに「いま .active が付いているピル」から
	// URLを組み直すので、非同期で一覧を入れ替えたあとも各ピルの href が古くならない
	// （絞り込みは .js-entries__body の外にあり、差し替えの対象にならないため）。
	//
	// 軸の中は OR、軸をまたぐと AND。組み合わせ方はサーバー側（extention.php の
	// on_change_query）と揃えてある
	filterMulti(root){
		const base = root.dataset.filterBase || location.pathname;
		const pills = [...root.querySelectorAll('.js-entries__filter[data-param][data-slug]')];
		const clear = root.querySelector('.js-entries__filter[data-filter-clear]');

		// いまの選択からURLを作る。値はカンマ区切り（例 /result/?result_cat=it,infra）
		const buildUrl = ()=>{
			const params = {};
			pills.forEach((pill)=>{
				if( !pill.classList.contains('active') ) return;
				const key = pill.dataset.param;
				if( !params[key] ) params[key] = [];
				params[key].push(pill.dataset.slug);
			});
			const query = Object.keys(params)
				.map((key)=>`${key}=${params[key].map(encodeURIComponent).join(',')}`)
				.join('&');
			return query ? `${base}?${query}` : base;
		};

		// 各ピルの href を「自分を押したあとの状態」に更新する。
		// 一時的に .active を反転させて buildUrl を呼び、すぐ戻している。
		// これで中クリックや新規タブで開いたときもJSと同じ結果になる
		const syncHrefs = ()=>{
			pills.forEach((pill)=>{
				pill.classList.toggle('active');
				pill.setAttribute('href', buildUrl());
				pill.classList.toggle('active');
			});
			if( clear ) clear.setAttribute('href', base);
		};
		syncHrefs();

		pills.forEach((pill)=>{
			pill.addEventListener('click', (e)=>{
				e.preventDefault();
				// 選択中のものを押したら外れる
				pill.classList.toggle('active');
				const url = buildUrl();
				syncHrefs();
				this.get(url, true);
			});
		});

		if( clear ) {
			clear.addEventListener('click', (e)=>{
				e.preventDefault();
				pills.forEach((pill)=>{ pill.classList.remove('active'); });
				syncHrefs();
				this.get(base, true);
			});
		}
	}


	// 一覧を丸ごと入れ替えたとき（カテゴリ／セレクトでの絞り込み）は先頭に戻す。
	// 例えば /news/page/4/ で40件表示している状態から2件のカテゴリに絞ると
	// ページが一気に短くなり、スクロール位置がそのままだとフッターが映ってしまう。
	// 「もっと見る」は追記なので対象外（読んでいた位置を保つ）。
	//
	// 慣性スクロール（Lenis）が有効なときはそちらに任せる。位置を直接いじると
	// Lenis の内部位置とズレて、次のホイール操作で元の位置に飛び戻る
	scrollToTop(){
		const top = Math.max(0, this.wrap.getBoundingClientRect().top + window.scrollY - 100); // 100 は固定ヘッダーぶん
		// すでに一覧より上にいるなら動かさない（下に飛ばされるのを防ぐ）
		if( window.scrollY <= top ) return;

		const lenis = (window.app && window.app.lenis) || window.lenis;
		if( lenis ) {
			// 入れ替えでページの高さが変わっているので、先に Lenis に測り直させる。
			// これをしないと内部の上限が古いままで、指定位置まで飛べない。
			// 位置は要素ではなく数値で渡す（要素だと解決に失敗することがある）
			lenis.resize();
			lenis.scrollTo(top, { immediate: true });
		} else {
			window.scrollTo(0, top);
		}
	}

	moreEvent(more){
		more.addEventListener('click', (e)=>{
			e.preventDefault();
			more.style.visibility = 'hidden';
			this.get(more.href, false);
		});
	}

	async get(url, all=true){
		const connect = (signal)=>{
			return new Promise((resolve, reject)=>{
				fetch(url, {
					credentials: 'include',
					cache: 'no-cache'
				})
					.then((res)=>{
						return res.text();
					})
					.then((text)=>{
						resolve(text);
					});
				this.signal.addEventListener('abort', ()=>{
					reject();
				});
			});
		};
		const change = (res)=>{
			const parser = new DOMParser();
			const newHTML = parser.parseFromString(res, 'text/html');
			const newBody = newHTML.querySelector('.js-entries__body');
			let newItems;
			let newMore;
			if( all ) {
				// 絞り込みで見出し情報も変わるページ（ソリューション）だけ、
				// タブのタイトルとパンくずを取得先のものに差し替える。
				// パンくずは .js_entries の外にあるので document から拾う
				const newTitle = newHTML.querySelector('title');
				if( newTitle ) document.title = newTitle.textContent;
				const crumbs = document.querySelector('.js-entries__crumbs');
				const newCrumbs = newHTML.querySelector('.js-entries__crumbs');
				if( crumbs && newCrumbs ) crumbs.innerHTML = newCrumbs.innerHTML;

				this.body.innerHTML = newBody.innerHTML;
				newItems = this.body.querySelector('.js-entries__items');
				newMore = this.body.querySelector('.js-entries__more');
				if( newItems ) {
					this.items = newItems;

					const newEntries = newItems.querySelectorAll(`.js-entries__entry:nth-child(n+${length+1})`);
					newEntries.forEach((entry, index)=>{
						entry.style.transitionDelay = `${index*0.05}s`;
						this.items.appendChild(entry);
						setTimeout(()=>{
							entry.classList.add('is-visible');
						}, 100);
					});


				}
				this.scrollToTop();
			} else {
				newItems = newBody.querySelector('.js-entries__items');
				newMore = newBody.querySelector('.js-entries__more');
				const length = this.items.querySelectorAll('.js-entries__entry').length;
				const newEntries = newItems.querySelectorAll(`.js-entries__entry:nth-child(n+${length+1})`);

				newEntries.forEach((entry, index)=>{
					entry.style.transitionDelay = `${index*0.05}s`;
					this.items.appendChild(entry);
					setTimeout(()=>{
						entry.classList.add('is-visible');
					}, 100);
				});
				if( this.more ) {
					this.body.removeChild(this.more);
				}
				if( newMore ) {
					this.body.appendChild(newMore);
				}
			}
			if( newMore ) {
				this.more = newMore;
				this.moreEvent(newMore);
			} else {
				this.more = null;
			}
			if( window.history.pushState && url ) {
				history.replaceState(null, null, url);
			}
		};
		if( this.controller ) {
			this.controller.abort();
		}
		this.controller = new AbortController();
		this.signal = this.controller.signal;
		try {
			const res = await connect();
			change(res);
		} catch(e) {
		}
	}
}

export default GetEntries;
